import React, { useContext, useEffect } from 'react';
import "./index.css"
import { filterDataContext } from '../../../../App';
import moment from "moment-timezone";


const CartMessage = ({ msg, checkoutPage, timeRemaining, convertedGuestPayload, isAPiLoading, handleReserveAgain, setTimeRemaining, fetchCartList, cartValidUntil }) => {

    const { reservationExpiredMsg } = useContext(filterDataContext)

    useEffect(() => {
        if (cartValidUntil) {
            const interval = setInterval(() => {
                const nowIST = moment().tz("Asia/Kolkata"); 
                const validUntil = moment(cartValidUntil.replace("Z", ""), "YYYY-MM-DDTHH:mm:ss.SSS").tz("Asia/Kolkata");

                const difference = moment.duration(validUntil.diff(nowIST));

                if (difference.asMilliseconds() > 0) {
                    const minutes = difference.minutes();
                    const seconds = difference.seconds();
                    setTimeRemaining(`${minutes}m ${seconds}s`);
                } else {
                    setTimeRemaining("Time expired");
                    clearInterval(interval);
                }
            }, 1000);

            return () => clearInterval(interval);
        }
    }, [cartValidUntil]);





    if (timeRemaining === "Time expired" && timeRemaining) {
        return <div className='cart_msg expired stickyMobile' style={{ margin: checkoutPage ? "0" : "1rem 0" }} >
            {
                reservationExpiredMsg ?
                    <span>{reservationExpiredMsg}</span>
                    :
                    <>
                        <span>Ticket are no longer reserved </span>
                        <button type='button' disabled={isAPiLoading} onClick={()=> handleReserveAgain(null)} className='reserve-button'>Reserve again </button>
                    </>
            }

        </div>
    }
    return (
        <div className='cart_msg stickyMobile' style={{ margin: checkoutPage ? "0" : "1rem 0" }} >
            <span>{msg}</span>
        </div>
    )
}

export default React.memo(CartMessage);